<template>
  <section class="admin-content">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ─────────────────────────────────────── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center p-t-40 p-b-40" style="gap: 20px;">
            <img
              :src="client.user.image_url"
              class="header-avatar"
              onerror="this.onerror=null; this.src='/assets/img/claimify_logo.png'"
            />
            <div class="text-white">
              <h2 class="page-title mb-1">{{ client.user.full_name }}</h2>
              <div class="d-flex align-items-center flex-wrap" style="gap: 8px; margin-top: 6px;">
                <span class="header-id-badge"
                v-if="client.user.enabled_user == true"
                >
                  <i class="fe fe-credit-card mr-1"></i>{{ client.user.id_card_number }}
                </span>
                <span v-if="client.user.status == 'active'" class="header-status header-status--active">
                  <i class="fe fe-check-circle mr-1"></i> Active
                </span>
                <span v-else class="header-status header-status--inactive">
                  <i class="fe fe-alert-circle mr-1"></i> Inactive
                </span>
                <span v-if="client.user.sector" class="header-id-badge">
                  <i class="fe fe-layers mr-1"></i>{{ client.user.sector }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- ── Action Bar (employee only) ─────────────────────── -->
        <div class="card action-card shadow mb-4" v-if="user && user.type == 'employee'">
          <div class="card-body py-3 px-4">
            <div class="d-flex flex-wrap align-items-center" style="gap: 8px;">

              <button @click="takePicAndroid" class="btn btn-sm btn-outline-primary">
                <i class="fe fe-camera mr-1"></i> Take Picture
              </button>

              <label class="btn btn-sm btn-outline-secondary mb-0" style="cursor: pointer;">
                <i class="fe fe-upload mr-1"></i> Upload Photo
                <input type="file" accept="image/*" style="display:none;" v-on:change="attachPic" />
              </label>

              <router-link :to="{ path: '/edit-user/' + $route.params.id }">
                <button class="btn btn-sm btn-outline-dark">
                  <i class="fe fe-edit mr-1"></i> Edit
                </button>
              </router-link>

              <router-link :to="{ path: '/add-dependent/' + $route.params.id }">
                <button class="btn btn-sm btn-outline-info">
                  <i class="fe fe-users mr-1"></i> Dependents
                </button>
              </router-link>

              <button type="button" class="btn btn-sm btn-info" @click="changeNumber(client)"
                v-if="user && (user.user_role == 1 || user.job_title == 'Enrollment Verification')">
                <i class="fe fe-hash mr-1"></i> Generate ID
              </button>

              <!-- More dropdown -->
              <div class="dropdown ml-auto">
                <button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fe fe-more-horizontal mr-1"></i> More
                </button>
                <div class="dropdown-menu dropdown-menu-right" style="min-width: 200px;">
                  <div class="dropdown-item" role="button" data-toggle="modal" data-target="#exampleModal">
                    <i class="mdi mdi-credit-card mr-2 text-info"></i> Add Payment
                  </div>
                  <div class="dropdown-item" role="button" @click="documentModal = !documentModal">
                    <i class="mdi mdi-file mr-2 text-info"></i> Add Document
                  </div>
                  <div class="dropdown-item" role="button"
                    data-toggle="modal" data-target="#slideRightModalAll" @click="getActivities">
                    <i class="fe fe-monitor mr-2 text-info"></i> Activities
                  </div>
                  <div class="dropdown-divider"></div>
                  <a :href="`/patient/${client.user.type}/${$route.params.id}`" class="dropdown-item">
                    <i class="mdi mdi-medical-bag mr-2 text-muted"></i> Utilizations
                  </a>
                  <router-link :to="{ path: '/client.user/biometrics/' + client.user.id }" class="dropdown-item">
                    <i class="mdi mdi-hand mr-2 text-muted"></i> Fingerprint
                  </router-link>
                  <a :href="'/enrollee_slip/' + client.user.id" class="dropdown-item">
                    <i class="fe fe-printer mr-2 text-muted"></i> Print Slip
                  </a>
                  <a :href="'/id_card/' + client.user.id" class="dropdown-item">
                    <i class="fe fe-credit-card mr-2 text-muted"></i> Print ID Card
                  </a>

                  <a :href="`/subscribe/${agency.id}/${client.user.id}`" class="dropdown-item">
                    <i class="fe fe-credit-card mr-2 text-muted"></i> Make Subscription
                  </a>

                  <template v-if="user && (user.user_role == 1 || user.job_title == 'Enrollment Verification')">
                    <div class="dropdown-divider"></div>
                    <div v-if="client.user.enabled_user == true"
                      class="dropdown-item text-danger" role="button" @click="deactivateUser">
                      <i class="fe fe-user-x mr-2"></i> Deactivate
                    </div>
                    <div v-else class="dropdown-item text-success" role="button" @click="enableUser">
                      <i class="fe fe-check-square mr-2"></i> Activate
                    </div>
                  </template>
                  <template v-if="user && (user.user_role == 1 || user.job_title == 'Enrollment Verification')">
                    <div class="dropdown-divider" v-if="!(user.user_role == 1)"></div>
                    <div class="dropdown-item text-danger" role="button" @click="deleteUser">
                      <i class="fe fe-trash-2 mr-2"></i> Delete
                    </div>
                  </template>
                </div>
              </div>

            </div>
          </div>

          <!-- Payment Modal -->
          <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content" style="border-radius:12px; overflow:hidden;">
                <div class="modal-header" style="background: linear-gradient(135deg,#1e3a5f,#2563eb);">
                  <h5 class="modal-title text-white" id="exampleModalLabel">
                    <i class="mdi mdi-credit-card mr-2"></i>Add Payment
                  </h5>
                  <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="form-group">
                    <label class="small font-weight-bold text-muted text-uppercase">Description</label>
                    <input type="text" class="form-control" placeholder="Payment description"
                      v-model="userPayment.description" />
                  </div>
                  <div class="form-group">
                    <label class="small font-weight-bold text-muted text-uppercase">Amount</label>
                    <input type="text" class="form-control" placeholder="Amount" v-model="userPayment.amount" />
                  </div>
                  <div class="form-group">
                    <label class="small font-weight-bold text-muted text-uppercase">Payment Date</label>
                    <input type="date" class="form-control" v-model="userPayment.date" />
                  </div>
                  <div class="form-group">
                    <label class="small font-weight-bold text-muted text-uppercase">Payment Proof</label>
                    <div class="fileinput fileinput-new" data-provides="fileinput">
                      <span class="btn btn-outline-secondary btn-sm btn-file">
                        <span class="fileinput-new"><i class="fe fe-upload mr-1"></i> Upload Proof</span>
                        <span class="fileinput-exists">Change</span>
                        <input type="file" accept="image/png, image/gif, image/jpeg" name="..."
                          multiple v-on:change="attachPaymentProof" />
                      </span>
                      <span class="fileinput-filename ml-2"></span>
                      <a href="#" class="close fileinput-exists" data-dismiss="fileinput" style="float:none">&times;</a>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Cancel</button>
                  <button type="button" class="btn btn-primary" data-dismiss="modal" @click="addPayment">
                    <i class="fe fe-send mr-1"></i> Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- End Payment Modal -->

          <!-- Document Modal -->
          <b-modal v-model="documentModal" title="Add Document">
            <form @submit.prevent="uploadDocument">
              <div class="form-group">
                <label class="small font-weight-bold text-muted text-uppercase">Document Type</label>
                <v-select v-model="document.name" :options="document_types" />
              </div>
              <div class="form-group">
                <label class="small font-weight-bold text-muted text-uppercase">Upload File</label>
                <div class="fileinput fileinput-new" data-provides="fileinput">
                  <span class="btn btn-outline-secondary btn-sm btn-file">
                    <span class="fileinput-new"><i class="fe fe-upload mr-1"></i> Choose File</span>
                    <span class="fileinput-exists">Change</span>
                    <input type="file" name="..." v-on:change="attachDocument" />
                  </span>
                  <span class="fileinput-filename ml-2"></span>
                  <a href="#" class="close fileinput-exists" data-dismiss="fileinput" style="float:none">&times;</a>
                </div>
                <button type="button" @click="takePicAndroidDoc" class="btn btn-outline-info btn-sm mt-2">
                  <i class="fe fe-camera mr-1"></i> Take Picture
                </button>
              </div>
              <img v-if="imagefile" :src="imagefile" class="rounded mt-2 img-fluid" alt="Document Preview" />
              <button type="submit" class="btn btn-primary btn-block mt-3">
                <i class="fe fe-upload mr-1"></i> Submit
              </button>
            </form>
          </b-modal>
          <!-- End Document Modal -->

        </div>

        <!-- ── Main Content ────────────────────────────────────── -->
        <div class="row">

          <!-- Left column -->
          <div class="col-lg-8 col-md-12">

            <!-- Profile Card -->
            <div class="card shadow-sm mb-4 profile-card">
              <div class="profile-card-header">
                <div class="d-flex align-items-center" style="gap: 16px;">
                  <img
                    :src="client.user.image_url"
                    class="profile-photo"
                    onerror="this.onerror=null; this.src='/assets/img/claimify_logo.png'"
                  />
                  <div>
                    <h5 class="mb-1 font-weight-bold text-dark">{{ client.user.full_name }}</h5>
                    <code class="code-chip" v-if="client.user.enabled_user == true">{{ client.user.id_card_number }}</code>
                    <p class="text-muted small mb-0 mt-1" v-if="client.user.sector">
                      <i class="fe fe-layers mr-1"></i>{{ client.user.sector }}
                    </p>
                  </div>
                </div>
                <img
                  :src="`https://claimify-api.hayokmedicare.ng/image/${agency.user_image}`"
                  class="agency-logo"
                  onerror="this.onerror=null; this.src='/assets/img/claimify_logo.png'"
                  :title="agency.agency_name"
                />
              </div>

              <div class="card-body p-0">
                <ul class="list-group list-group-flush">
                  <li class="info-row" v-if="client.user.expiry_date">
                    <i class="fe fe-calendar info-icon"></i>
                    <div>
                      <p class="info-label">Expiry Date</p>
                      <p class="info-value">{{ client.user.expiry_date | moment("MMMM Do YYYY") }}</p>
                    </div>
                  </li>
                  <li class="info-row" v-if="client.provider">
                    <i class="fe fe-home info-icon"></i>
                    <div>
                      <p class="info-label">Facility to Access Care</p>
                      <p class="info-value">{{ client.provider.agency_name }}</p>
                    </div>
                  </li>
                  <li class="info-row" v-if="client.user.place_of_work">
                    <i class="fe fe-briefcase info-icon"></i>
                    <div>
                      <p class="info-label">MDA / Place of Work</p>
                      <p class="info-value">{{ client.user.place_of_work }}</p>
                    </div>
                  </li>
                  <li class="info-row" v-if="client.tpa">
                    <i class="fe fe-shield info-icon"></i>
                    <div>
                      <p class="info-label">HMO</p>
                      <p class="info-value">{{ client.tpa.organization_name }}</p>
                    </div>
                  </li>
                  <li class="info-row" v-if="client.user.category_of_vulnerable_group">
                    <i class="fe fe-users info-icon"></i>
                    <div>
                      <p class="info-label">Vulnerable Group</p>
                      <p class="info-value">{{ client.user.category_of_vulnerable_group }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <SingleClientDocuments :documents="client.documents" />
            <SingleClientTransactions :transactions="client.transactions" />
            <SingleClientCOF :cofs="client.cofs" />
          </div>

          <!-- Right sidebar -->
          <div class="col-lg-4 col-md-12">
            <div class="card shadow-sm" style="border-radius: 14px; border: none;">
              <div class="card-header border-0 pt-4 pb-2 px-4"
                style="background: #f8f9fa; border-radius: 14px 14px 0 0;">
                <h6 class="mb-0 font-weight-bold text-dark">
                  <i class="fe fe-info text-primary mr-2"></i>Additional Details
                </h6>
              </div>
              <div class="card-body p-0">
                <ul class="list-group list-group-flush">
                  <li class="info-row">
                    <i class="fe fe-calendar info-icon"></i>
                    <div>
                      <p class="info-label">Date Enrolled</p>
                      <p class="info-value">{{ client.user.created_at | moment("MMM Do YYYY") }}</p>
                    </div>
                  </li>
                  <li class="info-row" v-for="(dep, index) in dependents" :key="dep.id">
                    <i class="fe fe-users info-icon"></i>
                    <div>
                      <p class="info-label">Dependent {{ index + 1 }}</p>
                      <p class="info-value">
                        <router-link :to="{ path: '/dependent/' + dep.id }">{{ dep.firstname }} {{ dep.lastname }}</router-link>
                        <span class="rel-chip ml-1">{{ dep.relationShipType }}</span>
                      </p>
                    </div>
                  </li>
                  <li class="info-row" v-if="client.enrolled_by">
                    <i class="fe fe-user-check info-icon"></i>
                    <div>
                      <p class="info-label">Enrolled By</p>
                      <p class="info-value">
                        {{ client.enrolled_by.firstname }} {{ client.enrolled_by.lastname }}
                      </p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-hash info-icon"></i>
                    <div>
                      <p class="info-label">NIMC Number</p>
                      <p class="info-value">{{ client.user.nimc_number || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-user info-icon"></i>
                    <div>
                      <p class="info-label">Gender</p>
                      <p class="info-value">{{ client.user.gender }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-heart info-icon"></i>
                    <div>
                      <p class="info-label">Blood Group</p>
                      <p class="info-value">{{ client.user.blood || 'NA' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-phone info-icon"></i>
                    <div>
                      <p class="info-label">Phone Number</p>
                      <p class="info-value">{{ client.user.phone_number }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-map-pin info-icon"></i>
                    <div>
                      <p class="info-label">LGA / Ward</p>
                      <p class="info-value">
                        <span v-if="client.local_government">{{ client.local_government.local_name }}</span>
                        <span v-if="client.ward"> / {{ client.ward.ward_name }}</span>
                        <span v-if="!client.local_government && !client.ward">—</span>
                      </p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-home info-icon"></i>
                    <div>
                      <p class="info-label">Community</p>
                      <p class="info-value">{{ client.user.community || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-gift info-icon"></i>
                    <div>
                      <p class="info-label">Date of Birth</p>
                      <p class="info-value">{{ client.user.dob | moment("D MMM YYYY") }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-mail info-icon"></i>
                    <div>
                      <p class="info-label">Email</p>
                      <p class="info-value">{{ client.user.email || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-smile info-icon"></i>
                    <div>
                      <p class="info-label">Marital Status</p>
                      <p class="info-value">{{ client.user.marital_status || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-tag info-icon"></i>
                    <div>
                      <p class="info-label">Previous ID</p>
                      <p class="info-value">{{ client.user.virtual_account || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-credit-card info-icon"></i>
                    <div>
                      <p class="info-label">Card Issued On</p>
                      <p class="info-value">{{ client.user.date_id_card_issued || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-map info-icon"></i>
                    <div>
                      <p class="info-label">Address</p>
                      <p class="info-value">{{ client.user.address1 || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-tool info-icon"></i>
                    <div>
                      <p class="info-label">Occupation</p>
                      <p class="info-value">{{ client.user.occupation || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-book info-icon"></i>
                    <div>
                      <p class="info-label">Education</p>
                      <p class="info-value">{{ client.user.education || '—' }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- ── Activities Slide-Right Modal ─────────────────────── -->
      <div class="modal fade modal-slide-right" id="slideRightModalAll" tabindex="-1" role="dialog"
        aria-labelledby="slideRightModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header align-items-center"
              style="background: linear-gradient(135deg,#1e3a5f,#2563eb);">
              <div class="d-flex align-items-center">
                <div class="mr-3 d-flex align-items-center justify-content-center"
                  style="width:38px;height:38px;background:rgba(255,255,255,.15);border-radius:10px;flex-shrink:0;">
                  <i class="fe fe-monitor text-white" style="font-size:1rem;"></i>
                </div>
                <div>
                  <h5 class="modal-title mb-0 text-white" id="slideRightModalLabel">User Activities</h5>
                  <small class="text-white-50">{{ client.user ? client.user.full_name : '' }}</small>
                </div>
              </div>
              <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body p-0">
              <div class="table-responsive">
                <table class="table mb-0" style="font-size:.85rem;">
                  <thead style="background:#f8fafc;">
                    <tr>
                      <th class="px-3 py-3 activities-th">Date</th>
                      <th class="py-3 activities-th">User</th>
                      <th class="py-3 activities-th">Changes</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="activity in activities.data" :key="activity.id" style="border-color:#f1f5f9;">
                      <td class="px-3 py-3">
                        <p class="mb-0" style="font-size:.83rem;">
                          {{ activity.created_at | moment("MMM Do YYYY") }}
                        </p>
                        <span class="badge badge-soft-success" style="font-size:.72rem;">
                          {{ activity.description }}
                        </span>
                      </td>
                      <td class="py-3" style="font-size:.83rem;">{{ activity.causer.full_name }}</td>
                      <td class="py-3">
                        <details>
                          <summary style="cursor:pointer;font-size:.8rem;color:#2563eb;">Show / Hide</summary>
                          <span v-for="(value, key) in activity.properties.attributes" :key="key"
                            class="d-block" style="font-size:.78rem;">{{ value }}</span>
                        </details>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-sm btn-outline-secondary" data-dismiss="modal">
                <i class="fe fe-x mr-1"></i> Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
      <PhotoCropper ref="photoCropper" />
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  import { randomAlphaNumeric } from "@/utils/secureRandom";
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // Init plugin
  import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
  import PhotoCropper from "@/components/PhotoCropper.vue";
  let agency = JSON.parse(localStorage.getItem("agency"));
  import fhis_providers from "@/json/fhis_provider_enrollees.json";
  import fhis_mda from "@/json/fhis_mda.json";
  import users_blood from "@/json/users_blood_group.json";

  import SingleClientDocuments from "./components/SingleClientDocuments";
  import SingleClientTransactions from "./components/SingleClientTransactions.vue";
  import SingleClientCOF from "./components/SingleClientCOF.vue";
  //  import jquery from 'jquery';

  export default {
    components: {
      Navbar,
      Loading,
      PhotoCropper,
      SingleClientDocuments,
      SingleClientTransactions,
      SingleClientCOF,
    },
    data() {
      return {
        agency: agency,
        fhis_providers: fhis_providers,
        fhis_mda: fhis_mda,
        users_blood: users_blood,
        activities: "",
        user: null,
        trx_image: false,
        documentModal: false,
        auth_user: "",
        client: { user: "full_name", transactions: [] },
        document_types: [
          "Registration Form",
          "Revalidation Form",
          "Renewal Receipt",
          "Credential",
          "Change of Facility",
          "Others",
        ],
        trx_doc: null,
        notes: "",
        dependents: "",
        medications: "",
        healthFacility: "",
        signature: "",
        enrolled_by: "",
        singleward: "",
        singlelga: "",
        edit: false,
        isLoading: false,
        fullPage: true,
        transactionID: "",
        agency_id: "",
        imagefile: "",
        image: "",
        paymentProofFile: null,
        paymentProofImage: "",
        output: "",
        singletpa: "",
        trxdocclass: "col-md-4",
        trxtableclass: "col-md-12",
        pictureShower: true,
        userPayment: {
          description: "",
          date: "",
          amount: "",
        },
        document: {
          name: "",
          document: "",
          document_picture: "",
        },
        transaction_ref_length: 50,
      };
    },

    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
        .then((response) => {
          this.client = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    computed: {
      randomTransId() {
        return randomAlphaNumeric(this.transaction_ref_length);
      },
    },

    methods: {
      addPayment() {
        if (confirm("Are you sure you want to Submit?")) {
          this.isLoading = true;
          this.axios
            .post(`/api/v1/make/transaction`, {
              user_id: this.$route.params.id,
              agency_id: agency.id,
              description: this.userPayment.description,
              amount: this.userPayment.amount,
              date: this.userPayment.date,
              type: "offline",
              status: "created",
              transaction_ref: this.randomTransId,
            })
            .then((response) => {
              this.transactionID = response.data.id;
              this.isLoading = false;
              this.$toasted.success("Payment Added Successfully", {
                position: "top-center",
                duration: 3000,
              });
              // this.fetchUser()
            })
            .catch((error) => {
              console.error(error);
              this.isLoading = false;
            });

          this.userPayment.description = "";
          this.userPayment.amount = "";
        }
        if (this.paymentProofFile != null) {
          setTimeout(() => {
            this.uploadPaymentProof();
          }, 3000);
        }


      },

      cleanDBEnrollee(client) {
        //Filter JSON

        //provider
        // let fhis_providers = this.fhis_providers;
        // let formatter = fhis_providers.filter(
        //   (x) => x.id_card_number == client.user.id_card_number
        // );
        // let enrollee_provider = formatter[0];

        // let provider_id =
        //   enrollee_provider == null
        //     ? client.user.provider_id
        //     : enrollee_provider.provider_id;
        // console.log(formatter);

        //mda
        // let fhis_mda = this.fhis_mda;
        // let formatterMDA = fhis_mda.filter(
        //   (x) => x.enrollee_id == client.user.previous_user_id
        // );
        // let enrollee_mda = formatterMDA[0];
        // console.log(formatterMDA);

        //Enrollee Blood users_blood
        //mda
        let users_blood = this.users_blood;
        let formatterBlood = users_blood.filter(
          (x) => x.previous_user_id == client.user.previous_user_id
        );
        let enrollee_blood = formatterBlood[0];
        console.log(formatterBlood);

        //End of Filter JSON

        this.axios
          .patch(`/api/v1/auth/clean-db-enrollee/${this.$route.params.id}`, {
            id_card_number: client.user.id_card_number,
            previous_user_id: client.user.previous_user_id,
            // provider_id: provider_id,
            // previous_alternate_provider_id: enrollee_provider.alternative_hcp_id,
            // previous_mda_id: enrollee_mda.organization_id,
            blood: enrollee_blood.blood_group,
          })
          .then((response) => {
            this.client.provider = response.data.user.userprovider;
            this.client.user.place_of_work = response.data.user.place_of_work;
            this.client.user.documents = response.data.user.documents;
            this.dependents = response.data.user.dependants;
            console.log(JSON.stringify(this.client.provider) + "hellox");
          })
          .catch((error) => {
            console.error(error);
          });
      },
      // User Picture Upload: crop first, then save through uploadcustomerpicImage
      attachPic(event) {
        const file = event.target.files[0];
        event.target.value = "";
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (e) => this.cropAndSavePic(e.target.result);
        reader.readAsDataURL(file);
      },
      // End of Picture Upload

      attachForm(event) {
        this.user = JSON.parse(localStorage.getItem("user"));
        console.log(event);
        this.image = event.target.files[0];
        this.uploadPictureForm();
      },
      uploadPictureForm() {
        this.isLoading = true;
        this.user = JSON.parse(localStorage.getItem("user"));
        var formData = new FormData();
        formData.append("enrollment_form", this.image);
        formData.append("user_id", this.$route.params.id);
        this.axios
          .post("/api/v1/upload-enrollment-form", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.$toasted.info("Form added Successfully!", {
              position: "top-center",
              duration: 3000,
            });
            this.fetchUser();
          });
        console.log(this.client);
      },
      attachPaymentProof(event) {
        this.user = JSON.parse(localStorage.getItem("user"));
        console.log(event);
        this.paymentProofFile = event.target.files[0];
        console.log(this.paymentProofFile);
      },

      uploadPaymentProof() {
        this.isLoading = true;
        this.user = JSON.parse(localStorage.getItem("user"));

        var formData = new FormData();
        formData.append("transaction_id", this.transactionID);
        formData.append("user_id", this.$route.params.id);
        formData.append("document", this.paymentProofFile);

        this.axios
          .post("/api/v1/auth/uploadTransactionDocument", formData)
          .then((response) => {
            this.paymentProofImage = response.data.document;
            console.log(response.data.document);
            this.isLoading = false;
            this.$toasted.success("Payment Added Successfully", {
              position: "top-center",
              duration: 3000,
            });
            this.fetchUser();
          });
      },

      async takePicAndroidDoc() {

        this.documentModal = false;

        const image = await Camera.getPhoto({
          quality: 90,
          allowEditing: false,
          resultType: CameraResultType.Base64,
          source: CameraSource.Camera,
        });

        var imageUrl = image.base64String;
        this.imagefile = "data:image/png;base64," + imageUrl;
        // this.document.document_picture = imageUrl;

        this.documentModal = true;

      },
      attachDocument(event) {
        console.log(event);
        this.document.document = event.target.files[0];
      },

      uploadDocument() {
        this.isLoading = true;
        this.user = JSON.parse(localStorage.getItem("user"));
        var formData = new FormData();
        formData.append("type_id", this.$route.params.id);
        formData.append("user_id", this.$route.params.id);
        formData.append("name", this.document.name);
        formData.append("document", this.document.document);
        formData.append("document_picture", this.imagefile);
        formData.append("type", "enrollee");
        this.axios
          .post("/api/v1/auth/documents", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.$toasted.info("Document uploaded Successfully", {
              position: "top-center",
              duration: 3000,
            });

            this.fetchUser();

            this.document.name = "";
          })
          .catch((error) => {
            this.$toasted.error("Error Uploading", {
              position: "top-center",
              duration: 3000,
            });
            console.error(error);
            this.isLoading = false;
          });
      },

      async takePicAndroid() {
        let image;
        try {
          image = await Camera.getPhoto({
            quality: 90,
            allowEditing: false,
            resultType: CameraResultType.Base64,
            source: CameraSource.Camera,
          });
        } catch (err) {
          if (err && err.message !== "User cancelled photos app") {
            this.$toasted.error("Could not access camera.", { position: "top-center", duration: 3000 });
          }
          return;
        }
        this.cropAndSavePic("data:image/jpeg;base64," + image.base64String);
      },

      async cropAndSavePic(src) {
        const cropped = await this.$refs.photoCropper.open(src);
        if (cropped) this.savePic(cropped);
      },

      savePic(image) {
        this.isLoading = true;
        this.axios
          .post(`/api/v1/auth/uploadcustomerpicImage`, {
            user_image: image,
            user_id: this.$route.params.id,
          })
          .then((response) => {
            console.log(response);
            this.$toasted.success("uploaded Successfully", {
              position: "top-center",
              duration: 3000,
            });
            this.fetchUser();
            this.isLoading = false;
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
          });
      },
      deleteUser() {
        if (confirm("Are you Sure you want to delete this user")) {
          this.axios
            .delete(`/api/v1/auth/deleteUser/${this.$route.params.id}`)
            .then((response) => {
              console.log(response);
              this.$router.push("/view-clients-agency");

              this.$toasted.success("Deleted Successfully", {
                position: "top-center",
                duration: 3000,
              });
            })
            .catch((error) => {
              console.error(error);
            });
        }
      },

      enableUser() {
        if (confirm("Are you Sure you want to activate?")) {
          this.axios
            .post(`/api/v1/auth/enableUser/` + this.$route.params.id)
            .then(() => {
              this.fetchUser();
              this.$toasted.info("Activated Successfully!", {
                position: "top-center",
                duration: 8000,
              });
            })
            .catch((error) => {
              console.error(error);
            });
        }
      },

      deactivateUser() {
        if (confirm("Are you Sure you want to deactivate?")) {
          this.axios
            .post(`/api/v1/auth/disableUser/` + this.$route.params.id)
            .then(() => {
              this.fetchUser();
              this.$toasted.info("Deactivated Successfully!", {
                position: "top-center",
                duration: 8000,
              });
            })
            .catch((error) => {
              console.error(error);
            });
        }
      },

      deleteTrx(trx) {
        if (confirm("Are you Sure you want to delete?")) {
          this.axios
            .delete(`/api/v1/auth/delete/transaction/${trx.id}`)
            .then((response) => {
              console.log(response);
              this.fetchUser();
              this.$toasted.success("Deleted Successfully", {
                position: "top-center",
                duration: 3000,
              });
            })
            .catch((error) => {
              console.error(error);
            });
        }
      },

      fetchUser() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
          .then((response) => {
            this.client = response.data;
            this.dependents = response.data.dependents;
            // this.cleanDBEnrollee(this.client);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      uploadPic() {
        this.isLoading = true;
        let snap = localStorage.getItem("snap");

        var formData = new FormData();
        formData.append("user_image", snap);
        this.axios
          .post("/api/v1/auth/uploadUserImage", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.$breadstick.notify("Profile Image changed Successfully!", {
              position: "top-right",
            });
            // this.getUser()
          });
      },
      // uploadPaymentProof() {
      //   this.isLoading = true;
      //   let snap = localStorage.getItem("snap");

      //   var formData = new FormData();
      //   formData.append("user_image", snap);
      //   this.axios
      //     .post("/api/v1/auth/uploadUserImage", formData, {
      //       headers: {
      //         "Content-Type": "multipart/form-data",
      //       },
      //     })
      //     .then((response) => {
      //       console.log(response);
      //       this.isLoading = false;
      //       this.$breadstick.notify("Profile Image changed Successfully!", {
      //         position: "top-right",
      //       });
      //       // this.getUser()
      //     });
      // },

      getActivities() {
        this.axios
          .get(`/api/v1/auth/activities-on-user/${this.$route.params.id}`, {
            params: {
              model: "App\\Models\\User",
            },
          })
          .then((response) => {
            this.activities = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      changeNumber() {
        if (confirm("Are you Sure you Want to Change ID?")) {
          this.isLoading = true;
          this.axios
            .patch(
              `/api/v1/auth/id-card-number/change/${this.$route.params.id}`,
              {
                type: "client",
              }
            )
            .then((response) => {
              console.log(response);
              this.isLoading = false;
              this.fetchUser();
              this.$toasted.success("ID Updated Successfully", {
                position: "top-center",
                duration: 3000,
              });
            })
            .catch((error) => {
              console.error(error);
              this.$toasted.error("Not Found!", {
                position: "top-center",
                duration: 3000,
              });
              this.isLoading = false;
            });
        }
      },
    },
    created() {
      this.fetchUser();
    },
  };
</script>

<style>
  #slideRightModalAll {
    position: fixed !important;
  }

  #slideRightModalAll .modal-dialog {
    position: fixed !important;
    top: 0;
    right: 0;
    bottom: 0;
    height: 100vh !important;
    display: flex;
    flex-direction: column;
  }

  #slideRightModalAll .modal-content {
    height: 100vh !important;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  #slideRightModalAll .modal-body {
    flex: 1 1 auto;
    overflow-y: auto;
  }

  #slideRightModalAll .modal-header,
  #slideRightModalAll .modal-footer {
    flex-shrink: 0;
  }
</style>

<style scoped>
  /* ── Page Header ─────────────────────────────────────── */
  .page-header {
    background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
    padding-bottom: 60px;
  }

  .page-title {
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 0;
  }

  .header-avatar {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid rgba(255, 255, 255, 0.4);
    flex-shrink: 0;
  }

  .header-id-badge {
    display: inline-flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.18);
    color: #fff;
    font-size: 0.78rem;
    padding: 3px 10px;
    border-radius: 20px;
    font-weight: 500;
  }

  .header-status {
    display: inline-flex;
    align-items: center;
    font-size: 0.78rem;
    padding: 3px 10px;
    border-radius: 20px;
    font-weight: 600;
  }

  .header-status--active {
    background: rgba(16, 185, 129, 0.25);
    color: #6ee7b7;
  }

  .header-status--inactive {
    background: rgba(245, 158, 11, 0.25);
    color: #fcd34d;
  }

  /* ── Action Card ─────────────────────────────────────── */
  .action-card {
    border-radius: 14px;
    border: none;
  }

  /* ── Profile Card ────────────────────────────────────── */
  .profile-card {
    border-radius: 14px;
    border: none;
    overflow: hidden;
  }

  .profile-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid #f1f5f9;
    background: #fafbfc;
  }

  .profile-photo {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid #e2e8f0;
    flex-shrink: 0;
  }

  .agency-logo {
    width: 60px;
    height: 60px;
    object-fit: contain;
    border-radius: 8px;
    flex-shrink: 0;
  }

  .code-chip {
    display: inline-block;
    background: #eff6ff;
    color: #2563eb;
    font-size: 0.78rem;
    padding: 2px 8px;
    border-radius: 6px;
    font-family: monospace;
  }

  /* ── Info Rows ───────────────────────────────────────── */
  .info-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 20px;
    list-style: none;
    border-bottom: 1px solid #f1f5f9;
  }

  .info-row:last-child {
    border-bottom: none;
  }

  .info-icon {
    color: #2563eb;
    font-size: 0.95rem;
    margin-top: 2px;
    flex-shrink: 0;
  }

  .info-label {
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #94a3b8;
    margin-bottom: 1px;
    font-weight: 600;
  }

  .info-value {
    font-weight: 600;
    color: #1e293b;
    font-size: 0.9rem;
    margin-bottom: 0;
  }

  /* ── Dependent chip ──────────────────────────────────── */
  .rel-chip {
    display: inline-block;
    background: #eff6ff;
    color: #2563eb;
    font-size: 0.7rem;
    padding: 1px 7px;
    border-radius: 10px;
    font-weight: 600;
  }

  /* ── Activities table ────────────────────────────────── */
  .activities-th {
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #64748b;
    font-weight: 600;
    border-bottom: 2px solid #e2e8f0;
  }

  /* ── Legacy / kept ───────────────────────────────────── */
  .spacer {
    margin-left: 1px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .spacer-image {
    margin-top: 25px;
  }

  .spacer-top-bottom {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .spacer-top {
    margin-top: 50px;
  }

  #container {
    margin: 0px auto;
    width: 500px;
    height: 375px;
    border: 10px #333 solid;
  }

  #videoElement {
    width: 500px;
    height: 375px;
    background-color: #666;
  }

  th {
    text-align: center;
  }

  td {
    width: fit-content;
    text-align: center;
  }

  .payment__proof {
    width: 20%;
  }

  .payment__proof,
  svg,
  video,
  canvas,
  audio,
  iframe,
  embed,
  object {
    display: inline-block;
  }
</style>
